import { useMemo, useState } from 'react';

import useAuthContext from 'client/hooks/useAuthContext';
import useNotification from 'client/hooks/useNotification';
import * as authApi from 'client/services/auth';

export type MFAProps = {
  enabled?: boolean;
  code?: string;
};

type UseMFAType = {
  loading: boolean;
  toggleMFA: (params: MFAProps) => void;
  confirmMFA: (params: MFAProps) => void;
};

export const useMFA = (): UseMFAType => {
  const { setError } = useNotification();
  const { setUserContext } = useAuthContext();

  const [loading, setLoading] = useState<boolean>(false);
  const toggleMFA = (params: MFAProps) => {
    setLoading(true);
    authApi
      .toggle(params)
      .catch((error) => setError(error.message))
      .finally(() => setLoading(false));
  };

  const confirmMFA = (params: MFAProps) => {
    setLoading(true);
    authApi
      .confirm(params)
      .then(async (data) => {
        if (data) await setUserContext();
      })
      .catch((error) => setError(error.message))
      .finally(() => setLoading(false));
  };

  return useMemo(
    () => ({
      loading,
      toggleMFA,
      confirmMFA,
    }),
    [loading, toggleMFA],
  );
};

export default useMFA;
